import * as yup from "yup";
import { TEXT_REQUIRED, TEXT_STRING } from "../errorTexts";

export const VALIDATOR_ANY = yup.mixed().notRequired();
export const VALIDATOR_STRING_REQUIRED = yup
  .string()
  .required(TEXT_REQUIRED)
  .typeError(TEXT_STRING)
  .nullable();
